import { apiClient } from './client';

export type AppVersionPolicyAppType = 'customer' | 'business';
export type AppVersionPolicyPlatform = 'android' | 'ios';
export type AppVersionPolicyUpdateType = 'none' | 'recommend' | 'force';

export interface AppVersionPolicy {
  policySeq?: number;
  appType: AppVersionPolicyAppType;
  platform: AppVersionPolicyPlatform;
  currentVersion?: string | null;
  minVersion?: string | null;
  latestVersion?: string | null;
  updateType: AppVersionPolicyUpdateType;
  updateRequired?: boolean;
  forceUpdate?: boolean;
  recommendUpdate?: boolean;
  storeUrl?: string | null;
  fallbackStoreUrl?: string | null;
  title?: string | null;
  message?: string | null;
  enabled?: boolean;
}

export interface SaveAppVersionPolicyInput {
  appType: AppVersionPolicyAppType;
  platform: AppVersionPolicyPlatform;
  minVersion?: string | null;
  latestVersion?: string | null;
  updateType: AppVersionPolicyUpdateType;
  storeUrl?: string | null;
  fallbackStoreUrl?: string | null;
  title?: string | null;
  message?: string | null;
  enabled?: boolean;
}

const BASE = '/admin/app-version-policies';

export const appVersionPoliciesApi = {
  getPolicies: async (): Promise<AppVersionPolicy[]> => {
    const res = await apiClient.get<AppVersionPolicy[]>(BASE);
    return res.data;
  },

  savePolicy: async (
    input: SaveAppVersionPolicyInput,
  ): Promise<AppVersionPolicy> => {
    const res = await apiClient.post<AppVersionPolicy>(BASE, input);
    return res.data;
  },

  updateEnabled: async (
    policySeq: number,
    enabled: boolean,
  ): Promise<AppVersionPolicy> => {
    const res = await apiClient.patch<AppVersionPolicy>(
      `${BASE}/${policySeq}/enabled`,
      { enabled },
    );
    return res.data;
  },
};
